import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET,  Router,  RouterLink,  RouterLinkActive, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IBreadcrumb } from './breadcrumb.interface';

@Component({
    selector: 'app-breadcrumb',
    imports: [RouterLink],
    templateUrl: './breadcrumb.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent implements OnInit {

  breadcrumbs: IBreadcrumb[];
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.breadcrumbs = [];
    this.onRouteChanges();
  }

  ngOnInit() {
  }

  private onRouteChanges() {
    this.router.events.pipe(
      filter((event) : event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      let root: ActivatedRoute = this.activatedRoute.root;
      this.breadcrumbs = this.getBreadcrumbs(root);
    });
  }

  private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";

    //get the child routes
    let children: ActivatedRoute[] = route.children;

    //return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    //iterate over each children
    for (let child of children) {
      //verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      //verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      //get the route's URL segment
      let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

      url += `/${routeURL}`;

      let _label: string = child.snapshot.data[ROUTE_DATA_BREADCRUMB]
      if(_label.includes(':') ){
        let sp = routeURL.split('/');
        _label = sp[sp.length - 1];
      }
      let breadcrumb: IBreadcrumb = {
        label: _label,
        params: child.snapshot.queryParams,
        path: url
      };

      if(!breadcrumbs.some(b => b.label == breadcrumb.label)) {
        breadcrumbs.push(breadcrumb);
      }

      //recursive
      return this.getBreadcrumbs(child, url, breadcrumbs);


    }
    const breadcrumb1: IBreadcrumb = {
      label: "",
      params: [],
      path: ""
    };

    return [breadcrumb1];
  }

}
